<template>
  <div>
    <!--头部信息-->
    <div class="bill">
      <div class="factoring_tit w">
        <h2 class="factoring_h">票据业务</h2>
        <div class="limit">
          凭证贴现：对凭证提前贴现获得流动资金。录入票据或者接收上级供应商支付的凭证获得可贴现的金额  拆分支付：对凭证拆分向下级供应商</div>
        <button class="factoring_btn">立即申请</button>
      </div>
    </div>
    <!--头部信息-->
    <!--主要内容-->
    <div class="factoring_main w">
      <div class="bill_main">
        <ul class="bill_list">
          <li>电子商业汇票</li>
          <li>纸质商业汇票</li>
          <li>银行商业汇票</li>
        </ul>
      </div>
      <!--申请流程-->
      <div class="flow">
        <p class="flow_h tit_public colorF"><span class="tit_span">申请流程</span></p>
        <div class="flow_img">
          <img src="../../assets/images/bill.png" alt="申请流程">
        </div>
      </div>
      <!--申请流程-->


      <!--申请条件及所需资料-->
      <div class="condition">
        <p class="condition_h tit_public"><span class="tit_span">申请条件及所需资料</span></p>
        <ul class="condition_list">
          <li class="condition_li" v-for="(item,index) in conditionArr" :key="index">
            <span>{{item.compactName}}</span>
            <p>{{item.compactMain}}</p>
          </li>
        </ul>

      </div>
    </div>
    <!--主要内容-->
  </div>
</template>

<script>
  export default {
    // name: "factoring".
    data () {
      return {
        conditionArr: [
          {compactName: '01 合同信息', compactMain: '录入贸易基本信息，上 传合同附件，如果已经 录入过同样的合同则只 需要选择合同将会带出 合同信息'},
          {compactName: '02 发票信息', compactMain: '上传发票附件'},
          {compactName: '03 担保方信息', compactMain: '可选择录入担保方信息 ，加速融资进度，提高 融资比例可选择担保方 式，质押担保，抵押担 保，信用担保'},
          {compactName: '04 担保品信息', compactMain: '采用抵押担保模式需要 提供担保品信息（名称 ，数量价值等）'}
        ]  // 申请条件附件
      };
    }
  };
</script>

<style scoped lang="scss">
  .w {
    width: 1140px;
    margin: 0 auto;
  }

  .colorF {
    color: #00C0FF
  }

  /*公共样式*/
  .tit_public {
    font-size: 26px;
    text-align: center;
    color: #00c0ff;
    margin: 74px 0 30px 0;
    .tit_span {
      border-bottom: 1px solid #00c0ff;
      padding-bottom: 5px;
    }
  }


  /*顶部介绍*/
  .bill {
    width: 100%;
    height: 451px;
    background: url(../../assets/images/lease_bg.jpg) center center no-repeat;
    color: #fff;
    position: relative;
    .factoring_tit {
      text-align: center;
      .factoring_h {
        font-size: 40px;
        padding: 58px 0;
      }
      .limit {
        width: 721px;
        line-height: 50px;
        text-align: center;
        margin: 0 auto;
    }
      .factoring_btn {
        width: 160px;
        line-height: 38px;
        font-size: 18px;
        color: #fff;
        background: #00C0FF;
        border-radius: 20px;
        display: block;
        position: absolute;
        bottom: 40px;
        left: 50%;
        margin-left: -80px;
        outline: none;
        border: none;
        cursor: pointer;
      }
    }
  }

  /* 介绍*/
  .bill_main {
    margin-top: 20px;
    height: 79px;
    background:  url(../../assets/images/bill_nav.jpg) 0 0 no-repeat;
    .bill_list{
      li{
        width: 33%;
        text-align: center;
        line-height: 79px;
        font-size: 26px;
        color:#fff;
        display: inline-block;
      }
    }
  }

  /*流程申请*/
  .flow {
    .flow_img{
      text-align: center;
      padding-top: 58px;
    }
  }

  /*申请条件*/
  .condition{
    .condition_list{
      padding: 20px 0 80px 0;
      @include clear;
      .condition_li{
        float: left;
        width: 212px;
        height: 225px;
        box-sizing: border-box;
        padding: 30px 12px 0 25px;
        background:  url(../../assets/images/masking.png);
        color:#fff;
        margin-right: 90px;
        &:last-of-type{
          margin-right: 0;
        }
        span{
          line-height: 45px;
          font-size: 20px;
        }
        p{
          font-size: 16px;
          line-height: 25px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Bill.vue?8b62e9c6